// export const baseURL = 'https://ekun.kekere.com/index.php/api/v1';
export const baseURL = 'https://api.kekere.com/index.php/api/v1';

// export const StorageBaseURL = 'https://ekun.kekere.com/storage/app/public';
export const StorageBaseURL = 'https://api.kekere.com/storage';
